import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import DefaultCPButton from '../../buttons/defaultCommandPanelButton';

export function CloseButton({
  content, onClick, disabled, className,
}) {
  return (
    <DefaultCPButton
      onClick={onClick}
      disabled={disabled}
      title={content}
      className={className}
      icon={<FontAwesomeIcon icon={faXmark} />}
      content="Закрити"
    />
  );
}

CloseButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

CloseButton.defaultProps = {
  onClick: () => null,
  content: 'Закрити',
  disabled: false,
  className: null,
};

export default CloseButton;
